<script>
  export default {
    name: 'paper-evaluations-label',
    props: ['evaluations'],
    computed: {
      labelType: function () {
        return this.evaluations > 1 ? 'success' : 'danger'
      }
    }
  }
</script>

<template>
  <el-tag :type="labelType">{{evaluations}}</el-tag>
</template>



// WEBPACK FOOTER //
// PaperEvaluationsLabel.vue?40749a36